import React, { useState, useCallback } from 'react'
import _ from 'underscore'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'

import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import Tooltip from 'components/Tooltip'

import EditNote from 'pages/shared/Note/EditNote'

import GA4 from 'helpers/ga4'

import { color } from 'styles/colors'

type variant = 'small' | 'large'

type props = {
  note: string
  className?: string
  variant?: variant
  onSaveNoteCallback: (updatedNote: string) => Promise<boolean>
}

const Note = ({ note, variant = 'small', className = '', onSaveNoteCallback }: props) => {
  const [showModal, setShowModal] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  const onNoteIconClick = () => {
    setShowModal(true)

    const eventData = { category: 'Customer Detail Page', action: 'Click Device Details Nav Button', label: 'Customer Notes' }

    GA4.sendEvent(eventData)
  }

  const onSaveCallback = useCallback(async (updatedNote: string) => {
    setIsSaving(true)

    await onSaveNoteCallback(updatedNote)

    setIsSaving(false)
    setShowModal(false)
  }, [onSaveNoteCallback])

  const onCloseCallback = useCallback(() => {
    setShowModal(false)
  }, [])

  return (
    <>
      <Tooltip title={`Notes: ${note ?? ''}`}>
        <S.Container onClick={onNoteIconClick}>
          <S.NoteIcon
            role="img"
            aria-label="notes"
            className={`${className} ${_.isEmpty(note) ? 'icon-note-hollow' : 'icon-note-filled'}`}
            variant={variant}
          />
        </S.Container>
      </Tooltip>
      {showModal && <EditNote isSaving={isSaving} note={note} onSaveCallback={onSaveCallback} closeCallback={onCloseCallback} />}
    </>
  )
}

export default Note

const S = {
  Container: styled(KeyboardAccessible)`
    height: 26px;
  `,
  NoteIcon: styled(StickyNote2OutlinedIcon)<{ variant: string, className: string }>`
    cursor: pointer;
    font-size: ${({ variant }) => variant === 'small' ? '22px' : '26px'};
    color: ${({ className }) => className.includes('icon-note-filled') ? color('filledNote') : color('emptyNote')};
    text-shadow: ${({ className }) =>
    className.includes('icon-note-filled')
      ? `-1px -1px 0 ${color('emptyNote')},
        1px -1px 0 ${color('emptyNote')},
        -1px 1px 0 ${color('emptyNote')},
          1px 1px 0 ${color('emptyNote')}
      `
      : 'none'};
  `
}
